import { useTranslation } from 'react-i18next'

import { FormFieldsContainer } from '../../../Form'
import { FormikWysiwygField } from '../../../Formik'
import {
  REQUEST_EDIT_DESCRIPTION_MODAL_FIELD_NAME,
  REQUEST_EDIT_DESCRIPTION_MODAL_FIELD_QA_NAME,
} from '../RequestEditDescriptionModal.constants'

function RequestEditDescriptionModalFields({ onInitEditor }) {
  const { t } = useTranslation()

  return (
    <FormFieldsContainer>
      <FormikWysiwygField
        autoFocus
        enablePasteAutolink
        enableTables
        name={REQUEST_EDIT_DESCRIPTION_MODAL_FIELD_NAME}
        placeholder={t('RequestProfile.EditDescriptionModalPlaceholderKey')}
        qaName={REQUEST_EDIT_DESCRIPTION_MODAL_FIELD_QA_NAME}
        onInit={onInitEditor}
      />
    </FormFieldsContainer>
  )
}

export default RequestEditDescriptionModalFields
